export { SkyPageSummaryTitleComponent } from './page-summary-title.component';
